import React, { useEffect, useRef, useState } from 'react';

import { Button } from '$partials/ui';
import { useMediaGallery } from './media-gallery';
import { IconPlay } from '$partials/icon';
import SimpleImage from './image-simple';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/media.d.ts').Video}
 */
const Video = ({
    autoplay = false,
    embed = {},
    loop = false,
    poster = '',
    posterClasses = '',
    title = '',
    onclick = () => {},
    preview
}) => {
    const ctx = useMediaGallery();
    const playerRef = useRef(null);

    useEffect(() => {
        if (ctx.videoId || ctx.initId) {
            playerRef?.current?.pause();
        } else {
            playerRef?.current?.play();
        }
    }, [ctx]);

    return (
        <>
            <div className={`${embed?.url ? '' : 'h-full'} w-full relative`}>
                <div
                    onClick={() => {
                        playerRef?.current?.pause();
                        onclick();
                    }}>
                    {preview ? (
                        <video
                            autoPlay
                            playsInline
                            className='w-full h-full'
                            loop={true}
                            muted={true}
                            poster={poster}
                            ref={playerRef}
                            src={preview}
                            title={title}/>
                    ) : (
                        <SimpleImage
                            className={`w-full ${posterClasses ? posterClasses : ''}`}
                            src={poster} />
                    )}
                </div>
                <div className='absolute top-14 left-14 text-text-default-invert z-10 flex'>
                    <Button
                        onClick={() => {
                            playerRef?.current?.pause();
                            onclick();}}
                        renderIcon={<IconPlay/>}/>
                </div>
            </div>
        </>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default Video;
